import _ from 'lodash';
import moment from 'moment';
import { loadPayment } from 'researcher/payment/actions';
import { loadUserInvoicingData } from 'researcher/user/actions';
import * as c from './constants';
var sortedInvoices = function sortedInvoices(invoices) {
  return _.sortBy(invoices, ['transactionDate']);
};
var oldestInvoiceDate = function oldestInvoiceDate(invoices) {
  var oldestInvoice = _.head(sortedInvoices(invoices));
  return oldestInvoice ? moment(oldestInvoice.transactionDate).toDate() : '';
};
var newestInvoiceDate = function newestInvoiceDate(invoices) {
  var newestInvoice = _.last(sortedInvoices(invoices));
  return newestInvoice ? moment(newestInvoice.transactionDate).toDate() : '';
};
export var loadInvoices = function loadInvoices(orderNumber) {
  return function (dispatch) {
    dispatch(loadPayment());
    return dispatch(loadUserInvoicingData()).then(function (user) {
      dispatch({
        type: c.INVOICE_LOADED,
        invoices: user.invoices,
        paymentMethods: user.paymentMethods,
        unpaidInvoices: user.unpaidInvoices,
        filters: {
          to: newestInvoiceDate(user.invoices),
          from: oldestInvoiceDate(user.invoices),
          orderNumber: orderNumber
        }
      });
    });
  };
};
export var onFapiaoCancelled = function onFapiaoCancelled(fapiao) {
  return {
    type: c.FAPIAO_CANCELLED,
    invoiceNumber: fapiao.receiptCode,
    fapiao: fapiao
  };
};
export var onChangeFilters = function onChangeFilters(data) {
  return {
    type: c.FILTERS_CHANGED,
    data: data
  };
};
export var onChangePage = function onChangePage(page) {
  return {
    type: c.PAGE_CHANGED,
    page: page
  };
};
export var resetFilters = function resetFilters(data) {
  return {
    type: c.FILTERS_CHANGED,
    data: data
  };
};
export var updateSelections = function updateSelections(selected, invoiceNumbers) {
  var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: c.SELECTIONS_UPDATED,
    invoiceNumbers: invoiceNumbers,
    replace: replace,
    selected: selected
  };
};
export var clearSelectedInvoiceNumbers = function clearSelectedInvoiceNumbers() {
  return {
    type: c.SELECTED_INVOICES_CLEARED
  };
};